import React from 'react'
import { Card, List, Typography } from 'antd'

const { Title, Text } = Typography;

const ServiceDetails = (props) => {
    return (
        <Card
            title={props.product.title}
            style={{
                borderRadius: 10, 
                marginBottom: 25,
                boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" 
            }}
        >
            <div
                dangerouslySetInnerHTML={{
                __html: props.product.description
                }}>
            </div>
            <List
                itemLayout="horizontal"
                header={<Title level={5} style={{textAlign:"center"}}>Package Includes</Title>}
                footer={<Text type="secondary" >If you have questions, make sure to contact me at matt@odinplatform.com</Text>}
                dataSource={props.product.package}
                renderItem={item => (
                <List.Item>
                    <List.Item.Meta
                        style={{textAlign:"center"}}
                        title={item.title}
                    />
                </List.Item>
                )}
            />
        </Card>
    )
}

export default ServiceDetails
